export enum PreviewSortAttributes {
	DOC_DATE = '_doc_time',
	SENTIMENT = '_degreesentimentindex',
	ML_SENTIMENT = 'xm_sentiment',
	EFFORT = 'cb_sentence_ease_score'
}

